module.exports = __webpack_public_path__ + "img/limpieza.cedf2540.svg";